module.exports = __webpack_public_path__ + "static/media/8.22336e14.JPG";